import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { http, errMsg } from "@/lib/api";

const L = ({ children }) => <span className="block text-[14px] mb-1">{children}</span>;

export const ContactForm = ({ listing = null, oggetto = "", compact = false }) => {
  const empty = {
    nome: "", telefono: "", email: "", oggetto,
    messaggio: listing ? `Spett.le IVCasa - Gruppo Immobiliare, Vi chiedo ulteriori informazioni sul Vostro annuncio Rif ${listing.riferimento}` : "",
  };
  const [f, setF] = useState(empty);
  const [privacy, setPrivacy] = useState("no");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (privacy !== "si") return toast.error("Per inviare il modulo è necessario autorizzare il trattamento dei dati personali.");
    setBusy(true);
    try {
      await http.post("/requests", {
        nome: f.nome, telefono: f.telefono, email: f.email, messaggio: f.messaggio,
        oggetto: listing ? `Richiesta info Rif ${listing.riferimento}` : f.oggetto,
        tipologia: listing ? "Richiesta immobile" : f.oggetto.startsWith("Candidatura") ? "Candidatura" : "Contatto",
        listing_id: listing?.id, listing_titolo: listing?.titolo,
      });
      setDone(true);
      setF(empty);
      setPrivacy("no");
      toast.success("Modulo inviato correttamente. Sarete ricontattati dal nostro staff.");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="contact-form" className={`grid gap-3 ${compact ? "" : "sm:grid-cols-2 gap-x-6"}`}>
      <label><L>Nominativo*</L><input required className="iv-input" placeholder="Nominativo" value={f.nome} onChange={set("nome")} data-testid="contact-nome-input" /></label>
      <label><L>Telefono*</L><input required className="iv-input" placeholder="Telefono" value={f.telefono} onChange={set("telefono")} data-testid="contact-telefono-input" /></label>
      <label><L>E-mail*</L><input required type="email" className="iv-input" placeholder="E-mail" value={f.email} onChange={set("email")} data-testid="contact-email-input" /></label>
      {!listing && (
        <label><L>Oggetto*</L><input required className="iv-input" placeholder="Oggetto" value={f.oggetto} onChange={set("oggetto")} data-testid="contact-oggetto-input" /></label>
      )}
      <label className={compact ? "" : "sm:col-span-2"}>
        <L>{listing ? "Richiesta*" : "Motivo*"}</L>
        <textarea required rows={compact ? 3 : 5} className="iv-textarea" value={f.messaggio} onChange={set("messaggio")} data-testid="contact-messaggio-input" />
      </label>
      <div className={`text-[13px] ${compact ? "" : "sm:col-span-2"}`}>
        <p className="font-bold">Autorizzazione al trattamento dei dati personali</p>
        <p className="mt-1">Dichiaro di aver letto l'informativa sulla privacy ed accetto le condizioni d'utilizzo del servizio.</p>
        <div className="flex items-center gap-10 mt-2 text-sm">
          <label className="flex items-center gap-2">Si* <input type="radio" name="privacy" value="si" checked={privacy === "si"} onChange={() => setPrivacy("si")} data-testid="contact-privacy-si" /></label>
          <label className="flex items-center gap-2">No <input type="radio" name="privacy" value="no" checked={privacy === "no"} onChange={() => setPrivacy("no")} data-testid="contact-privacy-no" /></label>
        </div>
      </div>
      <div className={`flex items-center gap-4 ${compact ? "justify-center" : "sm:col-span-2"} mt-2`}>
        <button type="submit" disabled={busy} data-testid="contact-submit-button"
          className="bg-[var(--iv)] text-white font-bold px-3 py-1.5 rounded-[3px] hover:bg-[var(--iv-dark)] transition-colors disabled:opacity-60 flex items-center gap-2">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Invia il modulo
        </button>
        {done && <span data-testid="contact-success-message" className="text-sm text-[var(--iv)] font-bold">Modulo inviato, grazie!</span>}
      </div>
    </form>
  );
};
